module.exports = __webpack_public_path__ + "img/logo.00956587.jpg";